var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11042",
    "data-name": "Group 11042",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.678,
    height: 28.98,
    viewBox: "0 0 28.678 28.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3125",
    "data-name": "Rectangle 3125",
    width: 28.678,
    height: 28.98,
    fill: "#2e728c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10741",
    "data-name": "Group 10741",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28975",
    "data-name": "Path 28975",
    d: "M27.159,29.772l-.017-.034-1.886-3.962A1.345,1.345,0,0,0,24.029,25h0a1.344,1.344,0,0,0-1.226.775l-1.888,3.967-.017.034-1.291,2.663a1.056,1.056,0,1,0,1.9.922l1.013-2.088h3.016l1.013,2.088a1.057,1.057,0,0,0,1.9-.922Zm-3.628-.616.5-1.044.5,1.044Z",
    transform: "translate(-11.651 -14.935)",
    fill: "#2e728c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28976",
    "data-name": "Path 28976",
    d: "M46.057,24A1.056,1.056,0,0,0,45,25.057V32.3a1.057,1.057,0,1,0,2.113,0V25.057A1.056,1.056,0,0,0,46.057,24",
    transform: "translate(-26.888 -14.34)",
    fill: "#2e728c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28977",
    "data-name": "Path 28977",
    d: "M27.621,17.207H26.263V11.773h1.358a1.057,1.057,0,0,0,0-2.113H26.263V9.509a7.1,7.1,0,0,0-7.094-7.094h-.151V1.057a1.057,1.057,0,0,0-2.113,0V2.415H11.471V1.057a1.057,1.057,0,1,0-2.113,0V2.423A7.1,7.1,0,0,0,2.415,9.509V9.66H1.057a1.057,1.057,0,0,0,0,2.113H2.415v5.434H1.057a1.057,1.057,0,1,0,0,2.113H2.415v.151a7.1,7.1,0,0,0,6.943,7.086v1.366a1.057,1.057,0,1,0,2.113,0V26.565H16.9v1.358a1.057,1.057,0,1,0,2.113,0V26.565h.151a7.1,7.1,0,0,0,7.094-7.094V19.32h1.358a1.057,1.057,0,1,0,0-2.113M24.15,19.471a4.987,4.987,0,0,1-4.981,4.981H9.509a4.987,4.987,0,0,1-4.981-4.981V9.509A4.986,4.986,0,0,1,9.509,4.528h9.66A4.987,4.987,0,0,1,24.15,9.509Z",
    fill: "#2e728c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.2df599b95da25660f9b706ed5d5c3891.svg";
export { ForwardRef as ReactComponent };